import {useEffect, useState} from 'react';

function useSlowAfter(delayMs: number) {
  const [isSlow, setIsSlow] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setIsSlow(true), delayMs);

    return () => clearTimeout(timeout);
  }, [delayMs]);

  return isSlow;
}

export {useSlowAfter};
